import { Card, Stack } from '@mui/material';
import {
    CreateButton,
    ListToolbar,
    Pagination,
    Title,
    TopToolbar,
} from 'react-admin';
import type { FormationSummary } from '@wwf/sdk';
import { FormationListContent } from './FormationListContent';
import { useFormationDrawer } from '../drawer/FormationDrawer';
import { useSearchParams } from 'react-router';
import { useRef } from 'react';
import { useEffect } from 'react';

export const FormationListLayout = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { openDrawer } = useFormationDrawer();

    const editIdFromUrl = searchParams.get('edit');
    const lastHandledEditId = useRef<string | null>(null);

    if (!editIdFromUrl) {
        lastHandledEditId.current = null;
    }

    useEffect(() => {
        if (!editIdFromUrl || editIdFromUrl === lastHandledEditId.current) {
            return;
        }
        lastHandledEditId.current = editIdFromUrl;
        openDrawer('edit', editIdFromUrl as FormationSummary['id']);
        setSearchParams(
            prev => {
                const next = new URLSearchParams(prev);
                next.delete('edit');
                return next;
            },
            { replace: true }
        );
    }, [editIdFromUrl, openDrawer, setSearchParams]);

    return (
        <Stack direction="row">
            <Stack sx={{ width: '100%' }}>
                <Title title={'formation'} />
                <ListToolbar
                    actions={
                        <FormationListActions
                            openCreateDrawer={() => openDrawer('create', null)}
                        />
                    }
                />
                <Card>
                    <FormationListContent
                        openEditDrawer={(id: FormationSummary['id']) =>
                            openDrawer('show', id)
                        }
                    />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const FormationListActions = ({
    openCreateDrawer,
}: {
    openCreateDrawer: () => void;
}) => (
    <TopToolbar>
        <CreateButton
            resource="formation"
            variant="contained"
            label="New Formation"
            onClick={openCreateDrawer}
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
